/**
 * Labelled inferences on a draft (fix-23): the drafter may reason when it labels each such sentence, and the card shows
 * the operator exactly which sentences those are. Pure, tested.
 */
export interface Inferred { sentence: string; from: string[] }

/** The body as runs of text, each marked if it is one of the inferred sentences. Unfound sentences mark nothing. */
export function markInferred(body: string, inferred: Inferred[]): { text: string; inferred: boolean }[] {
  const spans: [number, number][] = [];
  for (const { sentence } of inferred) {
    const at = sentence ? body.indexOf(sentence) : -1;
    if (at >= 0) spans.push([at, at + sentence.length]);
  }
  spans.sort((a, b) => a[0] - b[0]);
  const out: { text: string; inferred: boolean }[] = [];
  let pos = 0;
  for (const [s, e] of spans) {
    if (s < pos) continue; // overlapping labels: the first wins
    if (s > pos) out.push({ text: body.slice(pos, s), inferred: false });
    out.push({ text: body.slice(s, e), inferred: true });
    pos = e;
  }
  if (pos < body.length) out.push({ text: body.slice(pos), inferred: false });
  return out;
}
